var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "swiper",
    {
      ref: _vm.reference,
      attrs: { options: _vm.options },
      on: { progress: _vm.onProgress, touchEnd: _vm.onTouchEnd }
    },
    _vm._l(_vm.slides, function(slide) {
      return _c(
        "swiper-slide",
        { key: slide.id },
        [
          _c("bg-image", {
            staticClass: "slide-bg",
            attrs: { src: slide.background }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "slide-photos" },
            _vm._l(slide.photos, function(photo, index) {
              return _c("img", {
                key: index,
                staticClass: "slide-photo",
                attrs: {
                  src: photo.high,
                  alt: slide.year,
                  "data-swiper-parallax": "-200"
                }
              })
            }),
            0
          ),
          _vm._v(" "),
          slide.year || slide.text
            ? _c(
                "div",
                {
                  staticClass: "slide-year",
                  attrs: { "data-swiper-parallax": "-500" }
                },
                [
                  _c("p", {
                    staticClass: "year",
                    domProps: { innerHTML: _vm._s(slide.year) }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "year-line" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "sort-text" }, [
                    slide.sortText
                      ? _c("p", {
                          domProps: { innerHTML: _vm._s(slide.sortText) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    slide.modal
                      ? _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal",
                                value: slide.modal,
                                expression: "slide.modal"
                              }
                            ],
                            staticClass: "btn-more"
                          },
                          [_vm._v("read more")]
                        )
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }